/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PractitionersidPractitionerAddressesAttributes model module.
 * @module model/PractitionersidPractitionerAddressesAttributes
 * @version v0.3
 */
export default class PractitionersidPractitionerAddressesAttributes {
  /**
   * Constructs a new <code>PractitionersidPractitionerAddressesAttributes</code>.
   * @alias module:model/PractitionersidPractitionerAddressesAttributes
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PractitionersidPractitionerAddressesAttributes</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PractitionersidPractitionerAddressesAttributes} obj Optional instance to populate.
   * @return {module:model/PractitionersidPractitionerAddressesAttributes} The populated <code>PractitionersidPractitionerAddressesAttributes</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PractitionersidPractitionerAddressesAttributes();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('line1'))
        obj.line1 = ApiClient.convertToType(data['line1'], 'String');
      if (data.hasOwnProperty('line2'))
        obj.line2 = ApiClient.convertToType(data['line2'], 'String');
      if (data.hasOwnProperty('city'))
        obj.city = ApiClient.convertToType(data['city'], 'String');
      if (data.hasOwnProperty('state'))
        obj.state = ApiClient.convertToType(data['state'], 'String');
      if (data.hasOwnProperty('country'))
        obj.country = ApiClient.convertToType(data['country'], 'String');
      if (data.hasOwnProperty('zip'))
        obj.zip = ApiClient.convertToType(data['zip'], 'String');
      if (data.hasOwnProperty('primary'))
        obj.primary = ApiClient.convertToType(data['primary'], 'Boolean');
      if (data.hasOwnProperty('label'))
        obj.label = ApiClient.convertToType(data['label'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
    }
    return obj;
  }
}

/**
 * Provide an address ID only when updating an existing address
 * @member {String} id
 */
PractitionersidPractitionerAddressesAttributes.prototype.id = undefined;

/**
 * @member {String} line1
 */
PractitionersidPractitionerAddressesAttributes.prototype.line1 = undefined;

/**
 * @member {String} line2
 */
PractitionersidPractitionerAddressesAttributes.prototype.line2 = undefined;

/**
 * @member {String} city
 */
PractitionersidPractitionerAddressesAttributes.prototype.city = undefined;

/**
 * @member {String} state
 */
PractitionersidPractitionerAddressesAttributes.prototype.state = undefined;

/**
 * @member {String} country
 */
PractitionersidPractitionerAddressesAttributes.prototype.country = undefined;

/**
 * @member {String} zip
 */
PractitionersidPractitionerAddressesAttributes.prototype.zip = undefined;

/**
 * Primary adress. Only one allowed per practitioner.
 * @member {Boolean} primary
 */
PractitionersidPractitionerAddressesAttributes.prototype.primary = undefined;

/**
 * A label for the address, such as \"home\", \"office\", \"grandma's house\", etc.
 * @member {String} label
 */
PractitionersidPractitionerAddressesAttributes.prototype.label = undefined;

/**
 * Indicates whether the address is active
 * @member {Boolean} active
 */
PractitionersidPractitionerAddressesAttributes.prototype.active = undefined;

